var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "skip-container" }, [
      _c("div", { staticClass: "skip-content" }, [
        _c("i", { staticClass: "el-icon-loading" }),
        _c("p", { staticClass: "skip-text" }, [
          _vm._v("正在安全登录，请稍候..."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }